mutation UpdateProducts($input: [UpdateProductsInput!]!) {
  updateProducts(input: $input) {
    id
    publishAt
  }
}
